import { InputField, InputFields } from '@/hooks/forms/types';

export function getIsTouched(inputFields: InputFields): boolean {
	const fields: InputField[] = Object.values(inputFields);

	return fields.some(field => field.isTouched) && fields.some(field => field.value.length > 0);
}
